export default __webpack_public_path__ + "static/media/4-small.65fe54d4.png";